// @ts-nocheck b69e7e26
import * as core from '#packages/core';
import * as baseUI from '#packages/baseUI';
import * as util from '#packages/util';

const SUCCESS_DURATION = 1000;

export default {
  mixins: [baseUI.inputMixin, core.mixins.editorAPIMixin],

  ValidationStatus: {
    NONE: 'none',
    SUCCESS: 'success',
    ERROR: 'error',
  },
  getInitialState() {
    return { validationStatus: this.ValidationStatus.NONE };
  },

  componentDidMount() {
    this.mounted = true;
  },

  componentWillUnmount() {
    this.mounted = false;
  },

  openLinkDialogFromPanel() {
    this.openLinkDialog(true);
  },

  openLinkDialog(shouldLeaveParentPanelOpen) {
    const editorAPI = this.getEditorAPI();

    editorAPI.openLinkPanel(
      {
        link: util.valueLink.getValueFromProps(this.props),
        visibleSections: this.props.visibleSections,
        callback: this.linkUpdated,
      },
      !shouldLeaveParentPanelOpen,
    );
  },

  linkUpdated(newLink) {
    this.setState({ validationStatus: this.ValidationStatus.SUCCESS });
    util.valueLink.callOnChangeIfExists(this.props, newLink);

    window.setTimeout(
      function () {
        if (this.mounted) {
          this.setState({ validationStatus: this.ValidationStatus.NONE });
        }
      }.bind(this),
      SUCCESS_DURATION,
    );
  },
};
